export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperLocation = new Swiper('.swiper-location', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    autoHeight: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next.swiper-button-location',
      prevEl: '.swiper-button-prev.swiper-button-location',
    },
    pagination: {
      el: '.swiper-pagination.swiper-pagination-location',
      dynamicBullets: true,
      clickable: true,
    }
  });


  const swiperTestimonials = new Swiper('.swiper-testimonials', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 30,
    autoHeight: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
    pagination: {
      el: '.swiper-pagination.swiper-pagination-testimonials',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperPartners = new Swiper('.swiper-partners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    autoHeight: true,
    breakpoints: {
      992: {
        slidesPerView: 5,
        spaceBetween: 30,
      }
    },
    pagination: {
      el: '.swiper-pagination.swiper-pagination-partners',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const brandsSwiper = new Swiper('.brands-swiper', {
    slidesPerView: 5,
    centerInsufficientSlides: true,
    spaceBetween: 0,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next.brands-next',
      prevEl: '.swiper-button-prev.brands-prev',
    },
    pagination: {
      el: '.swiper-pagination.brands',
      clickable: true
    },
  });

}
